(function () {
  'use strict';

  angular
    .module('app.classes', []);

})();